'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCross = function TiCross(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 15c-0.2 0-0.4 0-0.6 0-1.4-3.9-5.5-6.7-9.8-6.7-5.5 0-10.4 4.5-10.4 10v0.2c-1.7 0.8-4.6 3.4-4.6 6.5 0 3.7 3.4 6.7 7.1 6.7h18.3c4.6 0 8.3-3.8 8.3-8.4s-3.7-8.3-8.3-8.3z m0 13.3h-7.5v-6.3l3.6 3.6c0.1 0.2 0.4 0.2 0.6 0.2s0.4-0.1 0.6-0.2c0.3-0.3 0.3-0.9 0-1.2l-5-5c-0.1-0.1-0.2-0.1-0.3-0.2-0.2-0.1-0.4-0.1-0.7 0-0.1 0.1-0.1 0.1-0.2 0.2l-5 5c-0.3 0.3-0.3 0.9 0 1.2 0.1 0.2 0.4 0.2 0.6 0.2s0.4-0.1 0.6-0.2l3.5-3.6v6.3h-9.1c-1.9 0-3.4-1.5-3.4-3.3s1.5-3.3 3.2-3.3l2.4 0-0.4-2c-0.1-0.5-0.2-0.9-0.2-1.4 0-3.6 3-6.6 6.7-6.6 3.3 0 6 2.3 6.6 5.5l0.3 1.9 1.8-0.5c0.5-0.2 0.9-0.3 1.3-0.3 2.8 0 5 2.3 5 5s-2.2 5-5 5z' })
        )
    );
};

exports.default = TiCross;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cross.js
// module id = 3802
// module chunks = 0